import { useUserPublicData } from 'hooks/user/useUserPublicData'
import { SingleContentToggle } from 'components/Atoms/SingleContentToggle'
import { UserOverviewPanel } from './UserOverviewPanel'
import { UserRedditPanel } from './UserRedditPanel'
import { useUser } from 'hooks/user/useUser'

export const UserOverview = () => {
  const { account } = useUser('wallet')
  const { isPending, isError, userPublicData, refreshData } =
    useUserPublicData(account)

  return (
    <SingleContentToggle
      toggle={userPublicData.redditData}
      trueContent={
        <UserRedditPanel
          userPublicData={userPublicData}
          isPending={isPending}
          refreshData={refreshData}
        />
      }
      falseContent={
        <UserOverviewPanel
          isForMe
          userPublicData={userPublicData}
          isPending={isPending}
          refreshData={refreshData}
        />
      }
    />
  )
}
